import { selectAllHeaders, toHeadersRecord } from '../../state/headers.js';
import getRequestWithBoundHeaders from './getRequestWithBoundHeaders.js';
import getTokenHeader from '../tokens/getTokenHeader.js';
export async function getAuthenticatedRequest(client) {
    const tokenHeader = await getTokenHeader(client);
    const otherHeaders = toHeadersRecord(selectAllHeaders(client.getState()));
    return getRequestWithBoundHeaders({
        ...otherHeaders,
        ...tokenHeader,
    });
}
